import React, { useContext, useEffect, useState } from "react";
import "./KnowledgeBaseList.scss";
// images
import searchIcon from "../../../../assets/icons/searchIcon.svg";
import DeleteKnowledge from "../DeleteKnowledge/DeleteKnowledge";
import cancelIcon from "../../../../assets/icons/cancelicon.svg";
import { SharedDataContext } from "../KnowledgeBasis";

const KnowledgeBaseList = () => {
  const { sharedData, setSharedData } = useContext(SharedDataContext);

  console.log("shared data :", sharedData);

  const [showDeleteComp, setShowDeleteComp] = useState(false);
  const [showUpdateComp, setShowUpdateComp] = useState(false);
  const [indexCheck, setIndexCheck] = useState();

  // Update Handle Start
  const handleHideUpdateComp = () => {
    setShowUpdateComp(false);
  };

  const handleShowUpdateComp = (index) => {
    setShowUpdateComp(true);
  };
  // Update Handle End

  // Delete box Handle Start
  const handleHideDeleteComp = () => {
    setShowDeleteComp(false);
  };

  const handleShowDeleteComp = (index) => {
    setShowDeleteComp(true);
    setIndexCheck(index);
    console.log("Clicked Delete Button for index:", index);
  };

  const handleDeleteComp = () => {};
  // Delete box Handle Start

  useEffect(() => {
    getAllQuestions();
  }, []);

  const [questions, setQuestion] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  const getAllQuestions = async () => {
    try {
      if (sharedData) {
        setIsLoading(true);
        console.log("Fetching Qs");
        const response = await fetch(`${process.env.REACT_APP_API_URL}/customer/questions/${sharedData.knowledgeId}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          setIsLoading(false);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("questions data :", data);
        setQuestion(data.responce);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching agent:", error);
      setIsLoading(false);
    }
  };

  console.log("knowledgebaseList", questions);

  return (
    <div className="nw">
      {showDeleteComp ? (
        // <DeleteKnowledge />
        <div>
          <div className="DeleteKnowledgeBase-main-container">
            <div className="DeleteKnowledgeBase-inner-container">
              <img className="" src={cancelIcon} alt="" onClick={() => handleHideDeleteComp()} />
              <h5>Are you absolutely sure?</h5>
              <p>This action can’t be undone. This will permanently delete this knowledge card from our servers.</p>
              <button className="deleteBbtn my-5" onClick={() => handleDeleteComp()}>
                Delete Action
              </button>
            </div>
          </div>
        </div>
      ) : showUpdateComp ? (
        <div className="updateAction-main-container">
          <div className="updateAction-head-container">
            {/* <h3>Create a new knowledge base</h3>
            <h5>Create a new knowledge base for Landev AI to answer questions for you</h5> */}
            <img src={cancelIcon} className="updateActionCancelIcon" alt="" onClick={handleHideUpdateComp} />
          </div>
          <div className="updateAction-main-box">
            <h2>Update Your Action</h2>
            <div>
              <span className="label-spans">
                <label htmlFor="">Name of action</label>
                <br />
                <input type="text" placeholder="eg. Support Knowledge Base" />
              </span>
              <br />
              <span className="label-spans">
                <label htmlFor="">Tell zapier to trigger this action when you Landev agent says something like:</label>
                <br />
                <input type="text" placeholder="“We provide a variety of file formats. For most applications, a hi" />
              </span>
            </div>
            <div className="updateActionSectionBtn-box">
              <button className="deleteBbtn">Delete Action</button>
              <button className="themebtn-1">Update Action</button>
            </div>
          </div>
        </div>
      ) : (
        <div div className="KnowledgeBaseList-main-container">
          <div className="d-flex justify-content-between align-items-center">
            <h3>Knowledge Base</h3>
            <button className="themebtn-1 createBaseBtn">Create Knowledge Base</button>
          </div>

          <div className="KnowledgeBaseList-search-container">
            <input type="text" placeholder="Search" name="" id="" />
            <img src={searchIcon} alt="" />
          </div>

          <div className="knowledgeBase-cards-container">
            {questions &&
              questions.map((item, index) => {
                return (
                  <div className="knowledgeBase-cards-box" key={index}>
                    <h5>{item.question}</h5>
                    <h6>{item.answer}</h6>
                    <div className="w-100 mt-5 d-flex justify-content-between align-items-center">
                      <button className="deleteBbtn" id={item.id} onClick={() => handleShowDeleteComp(index)}>
                        Delete Action
                      </button>
                      <button className="themebtn-1" onClick={() => handleShowUpdateComp(index)}>
                        Edit Action
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default KnowledgeBaseList;
